import S3FileUpload from 'react-s3';
import { aws } from '../Env';

const config = {
    bucketName: aws('bucket_name'),
    dirName: 'mt/phases',
    region: aws('region'),
    accessKeyId: aws('access_key'),
    secretAccessKey: aws('secret_key'),
}

export const S3 = (file) => {
    const d = new Date()
    let split_name = file[0].name.split('.')
    let ext = split_name[split_name.length - 1]
    let blob = file[0].slice(0, file[0].size, file[0].type);
    let newFile = new File([blob], `${d.getTime()}.${ext}`, {
        type: file[0].type
    });

    return new Promise(resolve => {
        S3FileUpload.uploadFile(newFile, config).then(data => {
            return resolve(data)
        }).catch(err => {
            return resolve(err)
        })
    })
}

export const Download = (e, links, name) => {
    fetch(links, {method: 'GET', headers: { "Cache-Control": 'no-cache' } })
    .then(res => {
        return res.blob();
    })
    .then(blob => {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = name;
        document.body.appendChild(a);
        a.click();  
        setTimeout(
        _ => { window.URL.revokeObjectURL(url); },
        60000);
        a.remove();
    })
    .catch(err => {
        console.error('err: ', err);
    })
}

export const DownloadImage = (e, link, name) => {
    try {
        // 1. Add cache-busting param
        const baseUrl = link.split('?')[0]; // Strip old params
        const cacheBustedUrl = `${baseUrl}?v=${Date.now()}`; // Add fresh timestamp
        // 2. Re-attach the original query params (if any)
        const queryParams = link.includes('?') ? '&' + link.split('?').slice(1).join('&') : '';
        const finalUrl = cacheBustedUrl + queryParams;

        // 3. Fetch the image as a blob
        fetch(finalUrl, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'Cache-Control': 'no-cache',
            },
        })
        .then(res => res.blob())
        .then(blob => {
            // 4. Create an image element
            const img = new Image();
            const url = URL.createObjectURL(blob);
            img.onload = () => {
                // 5. Create a canvas to resize the image
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                
                // Resize image to 1080x1080
                const targetSize = 1080;
                canvas.width = targetSize;
                canvas.height = targetSize;
                ctx.drawImage(img, 0, 0, targetSize, targetSize);

                // 6. Convert canvas back to a blob
                canvas.toBlob((resizedBlob) => {
                    const downloadUrl = window.URL.createObjectURL(resizedBlob);
                    const a = document.createElement('a');
                    a.href = downloadUrl;
                    a.download = name;
                    document.body.appendChild(a);
                    a.click();
                    setTimeout(() => window.URL.revokeObjectURL(downloadUrl), 60000);
                    a.remove();
                }, 'image/jpeg'); // Change MIME type if necessary (e.g., 'image/png' or 'image/jpeg')
            };

            img.src = url;
        })
        .catch(err => {
            console.error('❌ Download failed:', err);
        });
    } catch (err) {
        console.error('❌ Unexpected error in Download():', err);
    }
}
